module.exports = __webpack_public_path__ + "static/img/color-palette-3.54ba4c45.svg";